<template>
  <div class="compare-jobs-profile-search w-100">
    <DpplTreeselect
      :model-value="selectedProfiles"
      :async-search="asyncSearch"
      label=""
      search-appearance="inline"
      :placeholder="placeholder"
      :show-select-all="false"
      :max-height="240"
      id-key="ulid"
      label-key="title"
      @update:model-value="$emit('update:selectedProfiles', $event)"
      @add-snackbar="addErrorSnackbar"
    >
      <template #option-label="{ option }">
        <span class="compare-jobs-option-label">
          <span class="compare-jobs-option-title">{{ option.title || option.label }}</span>
          <CompareJobsLinkedIndicator
            v-if="isLinkedProfile(option.ulid)"
            :tooltip="linkedProfileTooltip"
            tooltip-placement="left"
          />
        </span>
      </template>
      <template #chip-prepend="{ option }">
        <CompareJobsLinkedIndicator
          v-if="isLinkedProfile(option.ulid)"
          :tooltip="linkedProfileTooltip"
          tooltip-placement="bottom"
        />
      </template>
    </DpplTreeselect>
  </div>
</template>

<script setup>
import DpplTreeselect from '@/components/datapeople/DpplTreeselect.vue';
import CompareJobsLinkedIndicator from '@/components/jobProfiles/editor/compareJobs/CompareJobsLinkedIndicator.vue';
import { useAppSnackbar } from '@/stores/app/snackbar';

const props = defineProps({
  selectedProfiles: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: 'Add profiles',
  },
  asyncSearch: {
    type: Function,
    required: true,
  },
  linkedProfileUlids: {
    type: Array,
    default: () => [],
  },
  linkedProfileTooltip: {
    type: String,
    default: '',
  },
});

defineEmits(['update:selectedProfiles']);

const { addErrorSnackbar } = useAppSnackbar();

const isLinkedProfile = (ulid) => props.linkedProfileUlids.includes(ulid);
</script>

<style scoped lang="less">
.compare-jobs-profile-search {
  :deep(.label-row) {
    display: none;
  }

  :deep(.actions.pr-4) {
    padding-right: 0 !important;
    width: 100%;
  }

  :deep(.tree-item-action:hover) {
    background: rgba(@icon-brand, .05);
  }

  :deep(input[type=checkbox]) {
    min-width: 15px;
    min-height: 15px;
    width: 15px;
    height: 15px;

    &::before {
      left: 4px;
      width: 5px;
      height: 9px;
    }
  }

  :deep(label) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: @text-light;
  }
}

.compare-jobs-option-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}

.compare-jobs-option-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
